export const stList = { list: null  || [] };
const _stateList = { list: null  || [] };


export let savedList = saveList(stList);
export function saveList(sl){
    _stateList.list = sl;
}


export function getList(){
    return  _stateList.list 
}